/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { css, styled, useFlux, useCallback } from 'fierry/react.old';

import Offset from 'astro/client/map/offset';
import Screen from 'shared/client/screen';
import Navigation from 'shared/client/navigation';

import Svg from 'astro/react/map/window/svg';
import Definitions from 'astro/react/map/window/definitions';


const OnZoneClick = (coords, galaxy, navigation) =>
{
  const location = galaxy.getLocation(coords);

  if (location)
  {
    console.log(`Zone (Absolute): ${location.getID()}`);
  }

  navigation.onZoneClick(location);
}


const getTransformStyle = (offset) =>
{
  const { x, y } = offset.getOffset();

  return { transform: `translate(${x}px, ${y}px)` };
};


const transitionConfig = ({ offset }) => !offset.isDnD() && css`
  transition-property:        transform;
  transition-duration:        var(--fierry-transition-duration);
  transition-timing-function: var(--fierry-transition-function);
`;


const Group = styled.g`
  ${transitionConfig}
`;


const Component = ({ screen, offset, children, onZoneClick }) =>
(
  <Svg width = {screen.getWindowWidth()} height = {screen.getWindowHeight()} onZoneClick = {onZoneClick} >

    <Definitions />

    {/* Transform changes too fast for styled - needs to be as separate style property */}
    <Group offset = {offset} style = {getTransformStyle(offset)}>
      {children}
    </Group>

  </Svg>
);


export default ({ galaxy, ...props }) =>
{
  const [ screen, offset, navigation ] = useFlux(Screen, Offset, Navigation);

  const onZoneClick = useCallback(OnZoneClick, [ galaxy, navigation ]);

  return <Component {...props} screen = {screen} offset = {offset} onZoneClick = {onZoneClick} />
};
